import React from "react";

const Principal = () => {
	return (
		<div className="principal faculty principal">
			<div className="container">
				<div className="title">In-Charge Principal</div>
				<div className="card">
					<div className="image">
						<img src="/assets/principal.jpg" alt="techarena" />
					</div>
					<div className="text">
						<div className="title"> Dr. Himanshu Dawda</div>
						<div className="subtitle">
							Dr. Himanshu Dawda had a brilliant career- Distinction in B.Sc., First Class in M.Sc.
							followed by a Doctorate in Plant Physiology. She did post-Doctoral research in Plant
							Biotechnology, Hairy Root Cultures, at Louisiana State ‘Varsity, U.S.A. in 1997, the area of
							her research being Downstream Processing. Scholarship and UGC Career Award in Science.
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Principal;
